// Watchman IAM role names
export const UserRole = {
  COLLECTIVE_SUPERADMIN: "COLLECTIVE_SUPERADMIN",
  COLLECTIVE_ADMIN: "COLLECTIVE_ADMIN",
  COLLECTIVE_USER: "COLLECTIVE_USER",
  MERCHANT_ADMIN: "MERCHANT_ADMIN",
  MERCHANT_USER: "MERCHANT_USER",
  // Tenant model P1 — TENANT-scoped roles for brand-website tenants.
  // Keep in lockstep with watchman prisma RoleName enum + seed ROLE_DEFAULTS.
  TENANT_ADMIN: "TENANT_ADMIN",
  TENANT_USER: "TENANT_USER",
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

// User decoded from Watchman JWT payload
export interface User {
  id: string;
  email: string;
  fullName: string;
  roleName: UserRole;
  roleScope: string;
  merchantId: string | null;
  isProfileCompleted: boolean;
  permissions: Record<string, string[]>;
}

export interface LoginCredentials {
  email: string;
  password: string;
  staySignedIn?: boolean;
}

// Raw response from Watchman POST /auth/login
export interface WatchmanLoginResponse {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresIn: number;
}

// Internal app login response (normalized)
export interface LoginResponse {
  token: string;
  user: User;
}